<template>
  <main id="onlinecity" @wheel="setHTMLbgColor">
    <router-view></router-view>
    <div class="site-loading" v-show="!siteLoaded">
    </div>

    <div v-show="showChatbubbles" @click="openChat" id="chatbubble"
         :class="{'chatbubble-is-online':$store.state.chatOnline}">
      <div class="chatbubble-circle"></div>
      <img :src="chatIconImage"/>
    </div>

  </main>
</template>

<script>

  import {changeLocale} from './multilanguage/locale';

  import chatIconsOff from './assets/chat-icons-off.png';
  import chatIconsOn from './assets/chat-icons-on.png';
  import logoMascot from './assets/logo-mascot.png';

  import {mapMutations, mapActions, mapGetters} from 'vuex';

  let scrollTimer, scrollTimer2;

  export default {
    name: 'app',
    data() {
      return {
        htmlBgColor: '#cfeff0',
        siteLoaded: false,
        showChatbubbles: true
      };
    },
    mounted() {
      document.addEventListener('chatlio.collapsed', (event) => {
        window._chatlio.hide();
        this.showChatbubbles = true;
      });
      document.addEventListener('chatlio.expanded', (event) => {
        updateChatlioImages();
        changeLocale();
      });
      document.addEventListener('chatlio.ready', (e) => {
        this.updateChatStatus();
        updateChatlioImages();
        changeLocale();
      });
      setInterval(() => {
        this.updateChatStatus();
      }, 10000);
      this.handleScroll();
      setTimeout(() => {
        this.handleScroll();
      }, 3000);
      setTimeout(() => {
        this.handleScroll();
      }, 5000);
    },
    created() {
      window.app = this;
      window.addEventListener('scroll', e => {
        this.handleScroll(e);
        this.setHTMLbgColor(e);
      });
      let _this = this;
      let loadCheck = setInterval(() => {
        if (document.readyState === 'complete') {
          _this.setSiteLoaded(true);
          _this.siteLoaded = true;
          clearInterval(loadCheck);
        }
      }, 200);
    },
    destroyed() {
      window.removeEventListener('scroll', this.handleScroll());
    },
    computed: {
      ...mapGetters({
        scrollLocked: 'getScrollLockState'
      }),
      chatIconImage() {
        if (this.$store.state.chatOnline) {
          return chatIconsOn;
        } else if (this.$store.state.chatOnline === false) {
          return chatIconsOff;
        } else {
          return chatIconsOff;
        }
      }
    },
    watch: {
      scrollLocked(val) {
        if (val) {
          document.querySelector('html').style.overflow = 'hidden';
        } else {
          document.querySelector('html').style.overflow = 'scroll';
        }
      }
    },
    methods: {
      ...mapActions([
        'setSiteLoaded',
        'setActiveSection'
      ]),
      ...mapMutations([
        'updateScrollY'
      ]),
      handleScroll(e) {
        this.updateScrollY(window.scrollY);
        if (scrollTimer) {
          clearTimeout(scrollTimer);
        }
        scrollTimer = setTimeout(() => {
          this.updateScrollY(window.scrollY);
        }, 500);
        if (scrollTimer2) {
          clearTimeout(scrollTimer2);
        }
        scrollTimer2 = setTimeout(() => {
          this.updateScrollY(window.scrollY);
        }, 1500);
      },
      setHTMLbgColor(e) {
        if (e.pageY > (this.$el.scrollHeight / 2)) {
          this.htmlBgColor = '#001a72';
        } else {
          this.htmlBgColor = '#d5eeef';
        }
        document.querySelector('html').style.backgroundColor = this.htmlBgColor;
      },
      updateChatStatus() {
        let isChatOnline = window._chatlio && window._chatlio.isOnline();
        this.$store.dispatch('setChatOnline', isChatOnline);
        window.updateChatlioImages();
      },
      openChat() {
        if (window._chatlio) {
          this.showChatbubbles = false;
          window._chatlio.show({expanded: true});
          setTimeout(function() {
            updateChatlioImages();
          }, 250);
        }
      }
    }
  };



console.log(
    `
%c    ++++%c+++%c+++%c++%c+++%c+++%c+++%c+++%c+++%c++++%c++++%c++++%c++++++
%c  ++%c#############################################%c+
%c +%c###############################################%c+
%c++%c###############################################%c+
%c++%c###############%c++++%c#########%c++++%c###############%c+
%c++%c##############%c++%c##%c++%c#######%c++%c##%c++%c##############%c+
%c++%c##############%c++%c##%c++%c#######%c++%c##%c++%c##############%c+
%c++%c##############%c++%c##%c++%c#######%c++%c##%c++%c##############%c+
%c++%c##############%c++%c##%c++%c#######%c++%c##%c++%c##############%c+
%c++%c###############%c++++%c#########%c++++%c###############%c+
%c++%c###############################################%c+
%c +%c##############################################%c+
%c  ++%c##########################################%c++
%c    ++++++++++%c++++%c++++%c++++%c++++%c++++%c++++%c+++%c+++%c+%c+`,
    'color: rgb(0, 133, 255)',
    'color: rgb(50, 133, 255)',
    'color: rgb(70, 133, 255)',
    'color: rgb(100, 133, 255)',
    'color: rgb(130, 133, 255)',
    'color: rgb(175, 130, 255)',
    'color: rgb(229, 115, 255)',
    'color: rgb(240, 150, 255)',
    'color: rgb(255, 170, 255)',
    'color: rgb(255, 170, 235)',
    'color: rgb(255, 160, 200)',
    'color: rgb(255, 130, 200)',
    'color: rgb(255, 100, 220)',
    'color: rgb(0, 133, 255)',
    'color: rgb(0, 0, 80)',
    'color: rgb(255, 75, 229)',
    'color: rgb(0, 133, 255)',
    'color: rgb(0, 0, 90)',
    'color: rgb(255, 75, 229)',
    'color: rgb(0, 133, 255)',
    'color: rgb(0, 0, 100)',
    'color: rgb(255, 75, 229)',
    'color: rgb(0, 133, 255)',
    'color: rgb(0, 0, 110)',
    'color: rgb(52, 240, 255)',
    'color: rgb(0, 0, 110)',
    'color: rgb(52, 240, 255)',
    'color: rgb(0, 0, 110)',
    'color: rgb(255, 75, 229)',
    'color: rgb(0, 133, 255)',
    'color: rgb(0, 0, 110)',
    'color: rgb(52, 240, 255)',
    'color: rgb(0, 0, 110)',
    'color: rgb(52, 240, 255)',
    'color: rgb(0, 0, 110)',
    'color: rgb(52, 240, 255)',
    'color: rgb(0, 0, 110)',
    'color: rgb(52, 240, 255)',
    'color: rgb(0, 0, 110)',
    'color: rgb(255, 75, 229)',
    'color: rgb(0, 135, 255)',
    'color: rgb(0, 0, 115)',
    'color: rgb(52, 240, 255)',
    'color: rgb(0, 0, 115)',
    'color: rgb(52, 240, 255)',
    'color: rgb(0, 0, 115)',
    'color: rgb(52, 240, 255)',
    'color: rgb(0, 0, 115)',
    'color: rgb(52, 240, 255)',
    'color: rgb(0, 0, 115)',
    'color: rgb(255, 75, 229)',
    'color: rgb(0, 140, 255)',
    'color: rgb(0, 0, 115)',
    'color: rgb(52, 240, 255)',
    'color: rgb(0, 0, 115)',
    'color: rgb(52, 240, 255)',
    'color: rgb(0, 0, 115)',
    'color: rgb(52, 240, 255)',
    'color: rgb(0, 0, 115)',
    'color: rgb(52, 240, 255)',
    'color: rgb(0, 0, 115)',
    'color: rgb(255, 75, 229)',
    'color: rgb(0, 150, 255)',
    'color: rgb(0, 0, 125)',
    'color: rgb(52, 240, 255)',
    'color: rgb(0, 0, 125)',
    'color: rgb(52, 240, 255)',
    'color: rgb(0, 0, 125)',
    'color: rgb(52, 240, 255)',
    'color: rgb(0, 0, 125)',
    'color: rgb(52, 240, 255)',
    'color: rgb(0, 0, 125)',
    'color: rgb(255, 75, 229)',
    'color: rgb(0, 160, 255)',
    'color: rgb(0, 0, 125)',
    'color: rgb(52, 240, 255)',
    'color: rgb(0, 0, 125)',
    'color: rgb(52, 240, 255)',
    'color: rgb(0, 0, 125)',
    'color: rgb(255, 75, 229)',
    'color: rgb(0, 170, 255)',
    'color: rgb(0, 0, 135)',
    'color: rgb(255, 75, 229)',
    'color: rgb(0, 180, 255)',
    'color: rgb(0, 0, 145)',
    'color: rgb(255, 100, 229)',
    'color: rgb(0, 180, 255)',
    'color: rgb(0, 0, 155)',
    'color: rgb(255, 130, 200)',
    'color: rgb(0, 180, 255)',
    'color: rgb(50, 150, 255)',
    'color: rgb(100, 150, 255)',
    'color: rgb(150, 130, 255)',
    'color: rgb(175, 130, 255)',
    'color: rgb(229, 115, 255)',
    'color: rgb(240, 150, 255)',
    'color: rgb(255, 170, 255)',
    'color: rgb(255, 180, 255)',
    'color: rgb(255, 160, 200)',
    'color: rgb(255, 130, 200)',
  );
  53;
  console.log(
    '%cHey! Do you want to help make this site even better?',
    'background: linear-gradient(to right, #61ECF3, #503BED); color: white; padding: 10px; border-radius: 10px; font-weight: 800; text-shadow: 1px 2px #558ABB;',
  );
  console.log('We are looking for a new Fullstack Developer for our team!');
  console.log('https://www.linkedin.com/jobs/view/4001538160/');



  
</script>

<style lang="scss">

/*
  @media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
    // IE10+ CSS here
}
*/


  .pcb-bg {
    width: 2255px;
    display: block;
    position: relative;
    left: 50%;
    // top: -160px;
    transform: translate(-50%, -234px);
    background-repeat: no-repeat;
    background-size: 100%;
    z-index: 1;
  }
  .pcb-dots {
    overflow: hidden;
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    .pcb-dot {
      width: 10px;
      height: 10px;
      margin-left: -5px;
      margin-top: -5px;
      position: absolute;
      border-radius: 10px;
      background-color: #c8e9ec;
      box-shadow: 0px 0px 10px 4px #c8e9ec;
      opacity: 0.9;
    }
  }
  .cls-1 {fill: none;stroke: #e66c42;stroke-miterlimit: 10;stroke-width: 4px;}
  body {
    overflow-x: hidden;
    position: relative;
    width: 100%;
    max-width: 100%;
  }
  html {
    background-color: #d5edef;
    overflow-x: hidden;
  }
  .site-loading {
    width: 100%;
    height: 100%;
    position: fixed;
    z-index: 999;
    top: 0;
    left: 0;
    background-color: rgb(186, 220, 229);
  }

  #chatlio-widget {
    .chatlio-title-bar {
      background: #01a9e0 !important;
      box-shadow: 0 0 12px rgba(0, 0, 0, 0.2);
    }
    .chatlio-widget.chatlio-open {
      right: 12px;
      bottom: 12px;
    }
    .chatlio-message-container {
      overflow-y: auto;
    }
    .chatlio-new-message-container {
    }
    .chatlio-message-avatar img {
      max-width: none;
    }
  }
  #chatbubble {
    box-shadow: 0 0 12px rgba(0, 0, 0, 0.2);
    width: 85px;
    height: 85px;
    border-radius: 100%;
    border-bottom-right-radius: 0;
    background: #01a9e0;
    position: fixed;
    right: 22px;
    bottom: 22px;
    z-index: 9000;
    .chatbubble-circle {
      background: #fb0700;
      border: 2px solid #ffffff;
      border-radius: 100%;
      width: 20px;
      height: 20px;
      position: absolute;
      left: 1px;
      top: 5px;
    }
    &.chatbubble-is-online {
      .chatbubble-circle {
        background: #00d600;
      }
    }
    img {
      width: 45px;
      height: 45px;
      border: none;
      display: block;
      position: absolute;
      left: 25px;
      top: 23px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/App.vue